import { FunctionComponent } from "react";
import { StyledTableBodyRow, StyledTableHeaderRow } from "./row.styles";

interface TableRowProps {
  children: any;
  header?: boolean;
  selected?: boolean;
  onClick?: () => void;
}

const TableRow: FunctionComponent<TableRowProps> = ({
  children,
  header = false,
  selected = false,
  onClick = () => {},
}) => {
  if (header) {
    return <StyledTableHeaderRow>{children}</StyledTableHeaderRow>;
  }
  return (
    <StyledTableBodyRow onClick={onClick} $selected={selected}>
      {children}
    </StyledTableBodyRow>
  );
};

export default TableRow;
